import { useTranslation } from 'react-i18next';

import {
  CatalogueListbox,
  CatalogueListboxProps,
} from '@/components/CatalogueListbox/CatalogueListbox';
import {
  activeOptionsStaleTime,
  rangeParams,
  TRangeActiveOptions,
} from '@/features/mentions/components/MentionFilters/active-options/active-options';

import { useLogoPicker } from '../hooks/use-logo-picker';

type LogoCatalogueListboxProps = CatalogueListboxProps & {
  labelsFilter?: string[];
  /** Narrows the listed logos to those present in the list's range. */
  activeOptions?: TRangeActiveOptions;
};

export function LogoCatalogueListbox({
  labelsFilter,
  activeOptions,
  ...listbox
}: LogoCatalogueListboxProps) {
  const { t } = useTranslation();
  const picker = useLogoPicker({
    value: listbox.mode === 'multiple' ? listbox.value : null,
    labelsIn: labelsFilter,
    range: activeOptions && rangeParams(activeOptions),
    staleTime: activeOptions && activeOptionsStaleTime(activeOptions.source),
    openOnMount: true,
  });

  return (
    <CatalogueListbox
      {...listbox}
      picker={picker}
      loadingMoreLabel={t('Cargando más logotipos...')}
      footerTestId="logo-filter-footer"
    />
  );
}
